module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-potential"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('costprice-per-hour')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('costs-division')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d666c6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/keyFigures.vue
// module id = 860
// module chunks = 0